import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import InputMask from 'react-input-mask';
import { useLocation, useParams } from 'react-router-dom';
import Spinner from '../../../shared/spinner';
import { Button } from 'react-bootstrap';
import CustomAlert from '../../../shared/customAlert';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import BancoService from '../../../services/bancoService';
import { Banco } from '../../../shared/model/banco';

function BancoInclusaoAlteracao() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  const location = useLocation();
  const { id } = location.state || {};
  const { tipo } = useParams();

  const tipoBancoDigital = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const tipoPermiteOperacao = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const tipoPermiteCompra = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const tipoAtivo = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const tiposConta = [
    { value: 'CC Individual', label: 'CC Individual' },
    { value: 'CP Individual', label: 'CP Individual' },
    { value: 'Conta Salário', label: 'Conta Salário' },
    { value: 'Conta Conjunta', label: 'Conta Conjunta' },
    { value: 'CP Conjunta', label: 'CP Conjunta' },
    { value: 'Conta Investimento', label: 'Conta Investimento' },
  ];

  const [numeroBanco, setNumeroBanco] = useState('');
  const [nome, setNome] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [bancoDigital, setBancoDigital] = useState(tipoBancoDigital[0].value);
  const [permiteOperacao, setPermiteOperacao] = useState(tipoPermiteOperacao[0].value);
  const [permiteCompra, setPermiteCompra] = useState(tipoPermiteCompra[0].value);
  const [ativo, setAtivo] = useState(tipoAtivo[0].value);
  const [tipoConta, setTipoConta] = useState('');
  const [operacao, setOperacao] = useState('');
  const [agencia, setAgencia] = useState('');
  const [dvAgencia, setDvAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [dvConta, setDvConta] = useState('');

  const [loading, setLoading] = useState(false);
  const bancoService: BancoService = new BancoService();

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (numeroBanco === '0' || numeroBanco === '') {
      setAlert({ message: 'Preencha o número do banco corretamente!', type: 'warning' });
      return;
    }
    if (nome.trim() === '') {
      setAlert({ message: 'Preencha o nome do banco!', type: 'warning' });
      return;
    }
    if (cnpj === '' || cnpj.length < 18) {
      setAlert({ message: 'Preencha o cnpj corretamente!', type: 'warning' });
      return;
    } else {
      setLoading(true);
      let banco: Banco = new Banco();
      banco.id = id;
      banco.numeroBanco = numeroBanco;
      banco.nome = nome;
      banco.cnpj = cnpj;
      banco.bancoDigital = bancoDigital === 'Sim' ? true : false;
      banco.permiteOperacao = permiteOperacao === 'Sim' ? true : false;
      banco.permiteCompra = permiteCompra === 'Sim' ? true : false;
      banco.ativo = ativo === 'Sim' ? true : false;
      banco.tipoConta = tipoConta;
      banco.operacao = operacao;
      banco.agencia = agencia;
      banco.dvAgencia = dvAgencia;
      banco.conta = conta;
      banco.dvConta = dvConta;

      try {
        const response = await bancoService.incluirAlterarBanco(banco)
          .then(() => setLoading(false));

        setAlert({ message: 'Alteração realizada com sucesso!', type: 'success' });
        await sleep(2000);

        window.location.href = '/parametros-banco';
      } catch (err) {
        setLoading(false);
        setAlert({ message: 'Ocorreu um erro ao criar/alterar banco!', type: 'error' });
        console.error(err);
      }
    }

  };

  const listarBancoPorId = async () => {
    setLoading(true);
    try {
      const response = await bancoService.listarBancoPorId(id);
      const jsonBanco = response.data;
      
      setNumeroBanco(jsonBanco.numeroBanco);
      setNome(jsonBanco.nome);
      setCnpj(jsonBanco.cnpj);
      setBancoDigital(jsonBanco.bancoDigital ? "Sim" : "Não");
      setPermiteOperacao(jsonBanco.permiteOperacao ? "Sim" : "Não");
      setPermiteCompra(jsonBanco.permiteCompra ? "Sim" : "Não");
      setAtivo(jsonBanco.ativo ? "Sim" : "Não");
      setTipoConta(jsonBanco.tipoConta);
      setOperacao(jsonBanco.operacao);
      setAgencia(jsonBanco.agencia);
      setDvAgencia(jsonBanco.dvAgencia);
      setConta(jsonBanco.conta);
      setDvConta(jsonBanco.dvConta);

      console.log(jsonBanco);

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  useEffect(() => {
    if (tipo === 'alteracao') {
      listarBancoPorId();
    }
  }, []);

  return (
    <div className="container">
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      {loading ? <Spinner loading={loading} /> : (
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              {tipo === 'inclusao' ? <h5>Parâmetros Cartão &gt; Cadastro de Bancos Digitais / Compra de Dívida &gt; Inclusão</h5> : (
                <h5>Parâmetros Cartão &gt; Cadastro de Bancos Digitais / Compra de Dívida &gt; Alteração</h5>
              )}
              <Button id="App-button-cor-principal" onClick={() => window.history.back()}>
                Voltar
              </Button>
            </div>
            <hr className="my-4" />
          </div>
          <div className="row">
            <div className="col-md-2">
              <label>Nº Banco <span style={{ color: 'red' }}>*</span></label>
              <InputMask required maskChar={null} mask="999" type="text" className="form-control" value={numeroBanco} onChange={(e) => setNumeroBanco((e.target.value))} />
            </div>
            <div className="col-md-5">
              <label>Nome <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={nome} onChange={(e) => setNome(e.target.value)} />
            </div>
            <div className="col-md-4">
              <label>CNPJ <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="99.999.999/9999-99" type="text" className="form-control" value={cnpj} onChange={(e) => setCnpj(e.target.value)} />
            </div>
          </div>

          <div className="row">
            <div className="col-md-2">
              <label>Banco Digital</label>
              <select className="form-select" defaultValue={bancoDigital[0]} value={bancoDigital} onChange={(e) => setBancoDigital(e.target.value)}>
                {tipoBancoDigital.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            {bancoDigital === "Sim" && (
              <div className="col-md-4">
              <label>Permite Pagamento de Operação em Bancos Digitais <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" defaultValue={permiteOperacao[0]} value={permiteOperacao} onChange={(e) => setPermiteOperacao(e.target.value)}>
                <option value="">{"Selecione uma Opção"}</option>
                {tipoPermiteOperacao.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            )}
            <div className="col-md-3">
              <label>Permite Compra de Dívida</label>
              <select className="form-select" defaultValue={permiteCompra[0]} value={permiteCompra} onChange={(e) => setPermiteCompra(e.target.value)}>
                {tipoPermiteCompra.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <label>Ativo</label>
              <select className="form-select" defaultValue={ativo[0]} value={ativo} onChange={(e) => setAtivo(e.target.value)}>
                {tipoAtivo.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <label>Tipo de Conta</label>
              <select className="form-select" defaultValue={tipoConta[0]} value={tipoConta} onChange={(e) => setTipoConta(e.target.value)}>
                <option value=""></option>
                {tiposConta.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <label>Operação</label>
              <input type="text" className="form-control" value={operacao} onChange={(e) => setOperacao(e.target.value)} />
            </div>
            <div className="col-md-2">
              <label>Agência</label>
              <input type="text" className="form-control" value={agencia} onChange={(e) => setAgencia(e.target.value)} />
            </div>
            <div className="col-md-1">
              <label>DV</label>
              <InputMask maskChar={null} mask="9" type="text" className="form-control" value={dvAgencia} onChange={(e) => setDvAgencia((e.target.value))} />
            </div>
            <div className="col-md-2">
              <label>Conta</label>
              <input type="text" className="form-control" value={conta} onChange={(e) => setConta(e.target.value)} />
            </div>
            <div className="col-md-1">
              <label>DV</label>
              <InputMask maskChar={null} mask="9" type="text" className="form-control" value={dvConta} onChange={(e) => setDvConta((e.target.value))} />
            </div>
          </div>

          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button className="w-40 btn btn-primary btn-lg btn btn-success" type="submit">{tipo !== 'inclusao' ? 'Alterar Cadastro de Banco' : 'Salvar Banco'}</button>
            </div>
          </div>
        </form>
      )
      }
    </div >
  );
}

export default BancoInclusaoAlteracao;